import {put, takeLatest, call} from 'redux-saga/effects';
import * as paymentService from "../../../services/paymentService";
import {
    REFUND,
    REFUND_SUCCESS,
    REFUND_ERROR,
}
    from "../../actions/payment"

function* refundSaga(action) {
    try {
       const data  = yield call(paymentService.Refund,action.payload)
       yield put({
        type: REFUND_SUCCESS,
        payload: data
    })


    } catch (error) {
        yield put({
            type: REFUND_ERROR,error: error.data
        })
    }
}


export function* refundSagaWatcher() {
    yield takeLatest(REFUND, refundSaga)
}